"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.persistor = exports.store = void 0;

var _redux = require("redux");

var _reduxPersist = require("redux-persist");

var _reducers = _interopRequireDefault(require("./reducers"));

var _initialState = _interopRequireDefault(require("./initialState"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var store = (0, _redux.createStore)(_reducers["default"], {
  BannerBelowHeaderBuilderComponent: (0, _initialState["default"])()
}, global.__REDUX_DEVTOOLS_EXTENSION__ && global.__REDUX_DEVTOOLS_EXTENSION__());
exports.store = store;
var persistor = (0, _reduxPersist.persistStore)(store);
exports.persistor = persistor;